var _excluded = ["size"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';

var FlagSk16 = function FlagSk16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.882 2h12.236C15.158 2 16 2.843 16 3.882v7.53c0 1.04-.843 1.882-1.882 1.882H1.882A1.882 1.882 0 0 1 0 11.412v-7.53C0 2.842.843 2 1.882 2zm0 .47c-.78 0-1.411.633-1.411 1.412v7.53c0 .78.632 1.411 1.411 1.411h12.236c.78 0 1.411-.632 1.411-1.411v-7.53c0-.78-.632-1.411-1.411-1.411H1.882z",
    fill: "#D8DDE1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.5 11.463c0 .745.604 1.35 1.35 1.35h12.3a1.35 1.35 0 0 0 1.35-1.35V3.85a1.35 1.35 0 0 0-1.35-1.35H1.85A1.35 1.35 0 0 0 .5 3.85v7.613z",
    fill: "#EE1C25"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.5 9.375h15V3.85a1.35 1.35 0 0 0-1.35-1.35H1.85A1.35 1.35 0 0 0 .5 3.85v5.525z",
    fill: "#0B4EA2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.5 5.938h15V3.85a1.35 1.35 0 0 0-1.35-1.35H1.85A1.35 1.35 0 0 0 .5 3.85v2.088z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.77 10.467c-.896-.446-2.178-1.33-2.178-3.078 0-1.748.081-2.543.081-2.543h4.195s.081.795.081 2.543c0 1.749-1.282 2.632-2.178 3.078",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.771 10.234c-.822-.408-1.999-1.219-1.999-2.823 0-1.603.075-2.333.075-2.333h3.848s.075.73.075 2.333c0 1.604-1.177 2.415-1.999 2.823z",
    fill: "#EE1C25"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.947 6.99c.222.004.657.013 1.044-.12 0 0-.01.143-.01.309s.01.309.01.309c-.355-.122-.793-.125-1.044-.122v.886h-.352v-.886c-.251-.003-.69 0-1.044.122 0 0 .01-.143.01-.31 0-.165-.01-.308-.01-.308.387.133.821.124 1.044.12v-.556a2.4 2.4 0 0 0-.826.123s.01-.143.01-.31c0-.166-.01-.308-.01-.308a2.4 2.4 0 0 0 .825.122 5.098 5.098 0 0 0-.11-.797s.205.017.287.017c.082 0 .286-.017.286-.017s-.1.444-.11.797c.203.002.495-.009.826-.123 0 0-.01.143-.01.31 0 .166.01.309.01.309a2.398 2.398 0 0 0-.826-.123v.557z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.77 8.156c-.413 0-.635.593-.635.593s-.123-.281-.461-.281c-.229 0-.397.21-.504.404.416.682 1.08 1.104 1.6 1.363.522-.26 1.186-.68 1.602-1.363-.107-.194-.275-.404-.504-.404-.338 0-.461.281-.461.281s-.222-.593-.636-.593z",
    fill: "#0B4EA2"
  }));
};

FlagSk16.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var sizeMap = {
  '16': FlagSk16
};
export var FlagSk = function FlagSk(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '16' : _ref$size,
      props = _objectWithoutProperties(_ref, _excluded);

  var Icon = sizeMap[size] || sizeMap['16'];

  if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test' && !sizeMap[size]) {
    throw new Error("The '".concat(size, "' size is not supported by the 'FlagSk' icon. Please use one of the available sizes: '16'."));
  }

  return /*#__PURE__*/React.createElement(Icon, props);
};